@if (icon) {
  <button mat-icon-button [matMenuTriggerFor]="languageMenu">
    <mat-icon>language</mat-icon>
  </button>
} @else {
  <button mat-raised-button color="primary" [matMenuTriggerFor]="languageMenu">
    {{ currentLanguage }}
  </button>
}
<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language) {
    <button mat-menu-item (click)="setLanguage(language)">
      {{ language }}
    </button>
  }
</mat-menu>
